export default "__VITE_ASSET__CGd2A2lI__"